import axios from 'axios'
import {
	Message,
	MessageBox,
} from 'element-ui'
import {
	getToken,
	setToken,
	removeToken
} from '@/tool/cookie'
import store from '../../store'

// 防止重复提交
let pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken; //初始化取消请求的构造函数
let arr = [] //区分是请求还是响应的头部（我的代码不需要区分）
let removePending = (config, f) => {
	arr = config.url;
	// arr = arr[arr.length - 1]
	let flagUrl = arr + '&' + config.method
	if (pending.indexOf(flagUrl) !== -1) {
		if (f) {
			f()
		} else {
			pending.splice(pending.indexOf(flagUrl), 1)
		}
	} else {
		if (f) {
			pending.push(flagUrl)
		}
	}
}


// 创建axios实例
const service = axios.create({
	baseURL: process.env.VUE_APP_ADMIN_BASE_URL, // api 的 base_url
	timeout: 20000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
	config => {
		// 防止重复提交
		// if (config.method === 'post') {
		// 	config.cancelToken = new cancelToken((c) => {
		// 		removePending(config, c);
		// 	});
		// }

		// if (111) {
		//   // let each request carry token
		//   // ['X-Token'] is a custom headers key
		//   // please modify it according to the actual situation
		let login_uid = getToken('login_uid');
		let token = getToken('token');
		if (login_uid && token) {
			config.data += '&login_uid=' + login_uid + '&token=' + token;
		}
		// }
		return config
	},
	error => {
		Promise.reject(error)
	}
)

// response 拦截器
service.interceptors.response.use(

	response => {
		// 防止重复提交
		// if (response.config.method === 'post') {
		// 	removePending(response.config)
		// }

		// 判断哪些要取消ajax加载状态
		let c = 'TaskSpongeman';
		let tj = ['TaskSpongemanLogin/login', 'TaskSpongemanLogin/reg', 'TaskSpongemanLogin/forgot', c +
			'/taskDraw', c + '/orderBuy', c + '/pl', c + '/orderComplain', c + '/accountSet', c + '/withdrawal',
			c + '/setUserIndex', c + '/changePwd',c+'/msgRead'
		];
		if (tj.includes(response.config.url)) {
			store.commit('setAjaxLoading', false);
		}

		const res = response.data
		if (res.error_code == 250) {
			Message({
				message: '你的用户登录已过期,请重新登录',
				type: 'error'
			});
			// 清除cookie
			removeToken('admin_name');
			removeToken('login_uid');
			removeToken('token');
			document.location = "/#/login"

			// MessageBox.confirm(
			//     '你的用户登录已过期，可以取消继续留在该页面，或者重新登录',
			//     '确定登出',
			//     {
			//       confirmButtonText: '重新登录',
			//       cancelButtonText: '取消',
			//       type: 'warning'
			//     }
			// ).then(() => {
			//     setToken("admin_session","")
			//     setToken("admin_name","")
			//   document.location="/#/admin_login"
			// })
			return Promise.reject(error)
		} else if (res.error_code !== 0) {
			Message({
				message: res.error_msg,
				type: 'error',
				duration: 5 * 1000
			})
			return Promise.reject(error)
			// return false;

		} else {
			return response.data;
		}
	},
	error => {
		Message({
			message: error.message,
			type: 'error',
			duration: 5 * 1000
		})
		return Promise.reject(error)
	}
)

export default service
